/* Fuego & Fragancia — escalera de cantidad de la zona de compra.
 *
 * Se apodera del formulario de producto: en vez de mandar 1 unidad de la
 * variante actual, manda las N piezas elegidas en las ranuras.
 *
 * REGLA DE REDONDEO (verificada con draftOrderCalculate, no supuesta):
 * Shopify trunca hacia abajo el descuento de CADA LINEA de pedido.
 *   3 aromas distintos @10% -> 3 lineas x floor(3535*10/100)=353  -> 95.46
 *   3 veces el mismo   @10% -> 1 linea  x floor(10605*10/100)=1060 -> 95.45
 * Por eso se agrupa por variante y se trunca linea por linea.
 */

if (!customElements.get('ff-qty-tiers')) {
  customElements.define(
    'ff-qty-tiers',
    class FfQtyTiers extends HTMLElement {
      connectedCallback() {
        this.radios = Array.from(this.querySelectorAll('.ff-qty__radio'));
        this.slots = Array.from(this.querySelectorAll('[data-ff-qty-slot]'));
        this.pickLabelEl = this.querySelector('[data-ff-qty-picklabel]');
        this.summaryEl = this.querySelector('[data-ff-qty-summary]');

        this.tplPick = this.dataset.pickLabel || 'CHOOSE YOUR SCENTS · PICK [n]';
        this.tplSummary = this.dataset.summary || '[n] jars · [total] — you save [saved]';
        this.defaultId = this.dataset.defaultId || '';

        this.form = this.dataset.form ? document.getElementById(this.dataset.form) : null;
        this.buyNow = document.querySelector('[data-ff-buy-now]');

        this.slots.forEach((slot) => this.setupSlot(slot));
        this.radios.forEach((r) => r.addEventListener('change', () => this.render()));

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }

        // Cerrar el desplegable abierto al tocar fuera o con Escape.
        this.onOutside = (e) => {
          if (!this.contains(e.target)) this.closeAll();
        };
        this.onKey = (e) => {
          if (e.key === 'Escape') this.closeAll();
        };
        document.addEventListener('click', this.onOutside);
        document.addEventListener('keydown', this.onKey);

        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('keydown', this.onKey);
      }

      setupSlot(slot) {
        const trigger = slot.querySelector('[data-ff-qty-trigger]');
        const menu = slot.querySelector('[data-ff-qty-menu]');
        const options = Array.from(slot.querySelectorAll('[data-ff-qty-option]'));

        slot._options = options;

        // La pieza que se esta viendo entra ya elegida en todas las ranuras:
        // asi la ficha es comprable de un solo clic. Quien quiera mezclar,
        // cambia las que quiera. Ademas repetir aroma sale un centavo MAS
        // BARATO que el precio anunciado, nunca mas caro.
        const porDefecto =
          options.find((o) => o.dataset.variantId === this.defaultId) || options[0];
        this.choose(slot, porDefecto, true);

        if (trigger) {
          trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const abierto = slot.classList.contains('is-open');
            this.closeAll();
            if (!abierto) {
              slot.classList.add('is-open');
              trigger.setAttribute('aria-expanded', 'true');
              if (menu) menu.hidden = false;
            }
          });
        }

        options.forEach((option) => {
          option.addEventListener('click', (e) => {
            e.stopPropagation();
            this.choose(slot, option);
            this.closeAll();
            this.render();
          });
        });
      }

      choose(slot, option, silencioso) {
        if (!option) return;

        slot._choice = {
          id: option.dataset.variantId,
          price: parseInt(option.dataset.price, 10) || 0,
          title: option.dataset.title || '',
        };

        const img = option.querySelector('img');
        const thumb = slot.querySelector('[data-ff-qty-thumb]');
        const chosen = slot.querySelector('[data-ff-qty-chosen]');

        if (thumb) {
          if (img) {
            thumb.src = img.currentSrc || img.src;
            thumb.hidden = false;
          } else {
            thumb.hidden = true;
          }
        }
        if (chosen) chosen.textContent = slot._choice.title;

        slot._options.forEach((o) =>
          o.classList.toggle('is-current', o === option)
        );

        if (!silencioso) this.render();
      }

      closeAll() {
        this.slots.forEach((slot) => {
          slot.classList.remove('is-open');
          const t = slot.querySelector('[data-ff-qty-trigger]');
          const m = slot.querySelector('[data-ff-qty-menu]');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (m) m.hidden = true;
        });
      }

      get target() {
        const c = this.radios.find((r) => r.checked);
        return c ? parseInt(c.value, 10) || 1 : 1;
      }

      get pct() {
        const c = this.radios.find((r) => r.checked);
        return c ? parseInt(c.dataset.pct, 10) || 0 : 0;
      }

      activeSlots() {
        return this.slots.slice(0, this.target);
      }

      money(cents) {
        if (window.ffMoney) return window.ffMoney(cents);
        return '$' + (cents / 100).toFixed(2);
      }

      /* Una linea de pedido por variante distinta, igual que hara el carrito. */
      lines() {
        const porVariante = new Map();
        this.activeSlots().forEach((slot) => {
          const c = slot._choice;
          if (!c) return;
          const linea = porVariante.get(c.id) || { id: c.id, price: c.price, qty: 0 };
          linea.qty += 1;
          porVariante.set(c.id, linea);
        });
        return Array.from(porVariante.values());
      }

      totals() {
        const pct = this.pct;
        let full = 0;
        let neto = 0;
        this.lines().forEach((l) => {
          const linea = l.price * l.qty;
          full += linea;
          neto += linea - Math.floor((linea * pct) / 100);
        });
        return { full: full, neto: neto, saved: full - neto };
      }

      render() {
        const n = this.target;
        const sums = this.totals();

        this.slots.forEach((slot, i) => {
          slot.hidden = i >= n;
        });

        if (this.pickLabelEl) {
          this.pickLabelEl.textContent = this.tplPick.replace('[n]', n);
        }

        if (this.summaryEl) {
          this.summaryEl.innerHTML = sums.saved > 0
            ? this.tplSummary
                .replace('[n]', n)
                .replace('[total]', '<strong>' + this.money(sums.neto) + '</strong>')
                .replace('[saved]', this.money(sums.saved))
            : '';
        }

        // El precio del boton de compra tiene que ser el del pack, no el de
        // una unidad, o la ficha promete una cifra y el carrito ensena otra.
        const totalEl = document.querySelector('[data-ff-add-total]');
        if (totalEl) totalEl.textContent = this.money(sums.neto);

        // COMPRAR AHORA es un <a> con permalink de carrito: /cart/id:cant,...
        if (this.buyNow) {
          const base = this.buyNow.dataset.cartBase || '/cart/';
          const partes = this.lines().map((l) => l.id + ':' + l.qty).join(',');
          if (partes) this.buyNow.href = base.replace(/\/$/, '') + '/' + partes;
        }
      }

      onSubmit(event) {
        const items = this.lines();
        if (!items.length) return;

        event.preventDefault();

        const boton = this.form.querySelector('[name="add"]');
        if (boton) boton.setAttribute('aria-disabled', 'true');

        const cartDrawer = document.querySelector('cart-drawer');
        const body = { items: items.map((l) => ({ id: Number(l.id), quantity: l.qty })) };

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((r) => {
            if (r.status) {
              console.error('[ff-qty-tiers]', r.description || r.message);
              return;
            }
            if (cartDrawer) {
              // Igual que product-form.js de Dawn: sin esto la clase is-empty
              // se queda pegada y convierte el panel flex en grid, rompiendo
              // el carrito entero.
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(r);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => console.error('[ff-qty-tiers]', e))
          .finally(() => {
            if (boton) boton.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
